/**
 * useFunnelUrlSync — sincroniza `funnelId` da URL com o funil selecionado.
 */
import { useEffect } from 'react';
import type { Page } from '../../../../types';

export function useFunnelUrlSync(
    currentPage: Page,
    selectedFunnelId: string | null,
    setSelectedFunnelId: (id: string | null) => void,
) {
    useEffect(() => {
        const pathname = window.location.pathname;
        const searchParams = new URLSearchParams(window.location.search);
        const urlFunnelId = searchParams.get('funnelId');

        if (currentPage === 'edit-funnel') {
            if (urlFunnelId && !selectedFunnelId) {
                setSelectedFunnelId(urlFunnelId);
            } else if (selectedFunnelId && urlFunnelId !== selectedFunnelId) {
                searchParams.set('funnelId', selectedFunnelId);
                window.history.replaceState({}, '', `${pathname}?${searchParams.toString()}`);
            }
            return;
        }

        if (currentPage === 'create-funnel' && urlFunnelId) {
            searchParams.delete('funnelId');
            const query = searchParams.toString();
            window.history.replaceState({}, '', query ? `${pathname}?${query}` : pathname);
        }
    }, [currentPage, selectedFunnelId, setSelectedFunnelId]);
}
